import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LogisticaService } from '../services/logistica.service';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';

@Component({
  selector: 'app-modal-historico-geografia',
  templateUrl: './modal-historico-geografia.component.html',
  styleUrls: ['./modal-historico-geografia.component.scss']
})
export class ModalHistoricoGeografiaComponent implements OnInit {
  historico: any[] = [];
  displayedColumns: string[] = ['FECHA_EVENTO', 'USUARIO_EVENTO', 'ACCION', 'DEPARTAMENTO', 'MUNICIPIO', 'ZONA'];

  constructor(
    public dialogRef: MatDialogRef<ModalHistoricoGeografiaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logisticaService: LogisticaService,
    private notificationService: NotificationHelper
  ) {}

  async ngOnInit(): Promise<void> {
    await this.cargarHistorico();
  }

  async cargarHistorico(): Promise<void> {
    showSpinner();
    try {
      const response = await this.logisticaService.obtenerHistorialGeografia(this.data.idPoligono);
      if (response && response.success) {
        this.historico = response.data;
      } else {
        this.notificationService.errorMessage('Error', 'No se pudo cargar el histórico');
      }
    } catch (error) {
      console.error('Error al cargar histórico:', error);
      this.notificationService.errorMessage('Error', 'Ocurrió un error al cargar el histórico');
    } finally {
      hideSpinner();
    }
  }

  cerrar(): void {
    this.dialogRef.close();
  }
}
